module.exports = __webpack_public_path__ + "img/Z81_06.3ceee5f8.jpg";